import Axios from 'axios'

const printer = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  calibratePrinter (printerModel) {
    return this.axios().post('/order/printer-calibration/v2/' + printerModel)
  },
  getPrinterModels () {
    return this.axios().get('/order/printer-models')
  }
}

export default printer
